const hasATBUrgencyMessage = (showUrgencyMessage, activeButtonLabel) => (
  (showUrgencyMessage && activeButtonLabel !== 'addToBagProcessing')
    ? 'atbUrgencyTitle'
    : activeButtonLabel
);
export default hasATBUrgencyMessage;
